import { SlideLayout } from './slides';
import { DEFAULT_LAYER_ORDER } from './layerOrder';

/**
 * Seeds a freeform layout approximating the original two-column grid design,
 * so first-time edits start from the familiar card arrangement.
 */
export const createDefaultLayout = (imageOnRight: boolean): SlideLayout => {
  const contentX = imageOnRight ? 5 : 55;
  const imageX = imageOnRight ? 57 : 7;

  return {
    background: imageOnRight ? 'imageRight' : 'imageLeft',
    layerOrder: [...DEFAULT_LAYER_ORDER],
    logo: { x: contentX, y: 9, w: 18, h: 7 },
    title: { x: contentX, y: 20, w: 42, h: 20 },
    highlights: { x: contentX, y: 43, w: 42, h: 48 },
    image: { x: imageX, y: 16, w: 36, h: 68 },
  };
};
